import React from 'react';
import './Footer.css';

function Footer() {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-text">
                    <h2><i>Developed By...</i></h2>
                </div>
                <div className="footer-logos">
                    <img src="/Bertozzi_Logo.png" alt="Bertozzi Group Logo" className="footer-logo"/>
                    <img src="/ChemH_Logo.png" alt="Sarafan ChEM-H Logo" className="footer-logo"/>
                    <img src="/HHMI_Logo.png" alt="HHMI Logo" className="footer-logo"/>
                </div>
            </div>
        </footer>
    )
}

export default Footer;